/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DeliveryBoxIsoClosedIcon16Light } from './DeliveryBoxIsoClosedIcon16Light';
import { DeliveryBoxIsoClosedIcon16Regular } from './DeliveryBoxIsoClosedIcon16Regular';
import { DeliveryBoxIsoClosedIcon16Solid } from './DeliveryBoxIsoClosedIcon16Solid';
import { DeliveryBoxIsoClosedIcon20Light } from './DeliveryBoxIsoClosedIcon20Light';
import { DeliveryBoxIsoClosedIcon20Regular } from './DeliveryBoxIsoClosedIcon20Regular';
import { DeliveryBoxIsoClosedIcon20Solid } from './DeliveryBoxIsoClosedIcon20Solid';
import { DeliveryBoxIsoClosedIcon24Regular } from './DeliveryBoxIsoClosedIcon24Regular';
import { DeliveryBoxIsoClosedIcon24Solid } from './DeliveryBoxIsoClosedIcon24Solid';
import { DeliveryBoxIsoClosedIcon32Regular } from './DeliveryBoxIsoClosedIcon32Regular';
import { DeliveryBoxIsoClosedIcon64Regular } from './DeliveryBoxIsoClosedIcon64Regular';
var sizes = {
    16: {
        light: DeliveryBoxIsoClosedIcon16Light,
        regular: DeliveryBoxIsoClosedIcon16Regular,
        solid: DeliveryBoxIsoClosedIcon16Solid,
    },
    20: {
        light: DeliveryBoxIsoClosedIcon20Light,
        regular: DeliveryBoxIsoClosedIcon20Regular,
        solid: DeliveryBoxIsoClosedIcon20Solid,
    },
    24: {
        regular: DeliveryBoxIsoClosedIcon24Regular,
        solid: DeliveryBoxIsoClosedIcon24Solid,
    },
    32: {
        regular: DeliveryBoxIsoClosedIcon32Regular,
    },
    64: {
        regular: DeliveryBoxIsoClosedIcon64Regular,
    },
};
export var DeliveryBoxIsoClosedIcon = forwardRef('DeliveryBoxIsoClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
